import { Loading } from 'element-ui'
const DmLoading = Loading
export default DmLoading
